<template>
    <div>
        <app-card
            headerIcon="attach_money"
            heading="New Invoices"
            colClasses=""
            customClasses="mb-0"
            :fullScreen="true"
            :reloadable="true"
            :closeable="true"
            :footer="true"
            :fullBlock="true"
            refreshMethod="refreshInvoices"
            :reload="reload"
        >
            <new-invoices></new-invoices>
            <v-spacer slot="footer"></v-spacer>
            <v-btn slot="footer" class="mr-2" color="primary" @click="$router.push({ name: 'invoices' })" small>{{ $t("lang.view_all") }}</v-btn>
            <v-btn slot="header" icon small @click="refreshInvoices"><v-icon>refresh</v-icon></v-btn>
        </app-card>
    </div>
</template>
<script>
import NewInvoices from "App_components/Widgets/NewInvoices.vue";
import { mapActions, mapState } from "vuex";
export default {
    components: {
        NewInvoices,
    },
    props: {
        refreshMethod: {
            type: Function,
        },
    },
    data() {
        return {
            name: "new_invoices",
            reload: false,
        };
    },
    computed: {
        ...mapState({
            dashboard_invoices: (state) => state.invoices.dashboard_invoices,
        }),
    },
    methods: {
        async refreshInvoices(refresh = false) {
            this.reload = true;
            if (refresh) {
                await this.$store.commit("commitInvoice", {
                    property: "dashboard_invoices",
                    with: null,
                });
            }

            await this.$store.dispatch("fetchInvoice", {
                url: "invoices",
                method: "get",
                stateProperty: "dashboard_invoices",
                dataProperty: "invoices",
                commit: true,
                body: {
                    invoice_status: ["draft", "sent", "approved"],
                },
            });
            this.reload = false;
        },
    },
};
</script>
